import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorBase } from '@shared/bases/control-value-accessor.base';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-toggle-switch',
	imports: [SharedModule],
	templateUrl: './toggle-switch.component.html',
	styleUrl: './toggle-switch.component.scss',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ToggleSwitchComponent),
			multi: true,
		},
	],
})
export class ToggleSwitchComponent extends ControlValueAccessorBase<boolean> {
	@Input() size: 'small' | 'large' = 'large';
	@Input() disabled = false;

	get checked(): boolean {
		return this.value || false;
	}

	set checked(val: boolean) {
		this.value = val;
	}

	onToggleChange(newValue: boolean): void {
		this.checked = newValue;
	}
}
